import { AppLink } from '@/global/components/AppLink'
import { WParagraph, WTitle } from '@alice-health/wonderland-react'
import { FunctionComponent, useContext } from 'react'
import { strings } from './CompanySuccess.helpers'
import { BLOG_URL } from '@/global/constants/routes'
import { sendGTMEvent } from '@next/third-parties/google'
import { SimulatorContext } from '@/modules/simulator/contexts'
import { EventName } from '@/global/utils/analytics-events/types/common'
import { useDispatchPageEvent } from '@/global/hooks'

const CompanySuccess: FunctionComponent = () => {
  useDispatchPageEvent({
    eventName: EventName.PAGE_VIEWED,
    pageTitle: 'Tela de sucesso visualizada'
  })

  const { simulation } = useContext(SimulatorContext)

  const name = simulation.answers.responsibleName || ''

  return (
    <div className='py-gl-spacing-06 px-gl-spacing-08 h-full flex flex-col justify-center'>
      <WParagraph className='text-gl-font-size-md'>{strings.note}</WParagraph>
      <WTitle
        className='mt-gl-spacing-02'
        size='small'
        variant='heavy'
      >
        {strings.description(name)}
      </WTitle>

      <AppLink
        className='self-start mt-gl-spacing-10'
        as='link'
        href={BLOG_URL}
        icon='icArrowRight'
        onClick={() => {
          sendGTMEvent({ event: 'mla_click_on_blog_link' })
        }}
      >
        {strings.linkLabel}
      </AppLink>
    </div>
  )
}

export { CompanySuccess }
